export default [
  {
    name: 'forbidden',
    path: '/forbidden',
    component: () => import(/* webpackChunkName: "forbidden" */ '../../../components/Forbidden.vue')
  }
]
